module.exports = {"540628100":"拉西镇","540628101":"杂色镇","540628102":"雅安镇","540628201":"江绵乡","540628202":"玛如乡","540628204":"阿秀乡","540628205":"贡日乡","540628206":"岗切乡","540628210":"巴青乡","540628211":"本塔乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540628.json
// module id = 2743
// module chunks = 0